import { createConsumer } from "@rails/actioncable"

const consumer =
  typeof window !== "undefined" ? createConsumer() : (null as unknown as ReturnType<typeof createConsumer>)

export default consumer
